import React, { useState } from "react";
import { useConfig, ModuleLoader } from "@eis-poc/lib-discover-medical-mfes";
import {
  Skeleton,
  useMediaQuery,
} from "discover.medical.react-component-library";
import {
  StyledWrap,
  StyledHeading,
  StyledParagraph,
  StyledSearch,
  StyledSearchLoader,
} from "./_.styled";
import ErrorBoundary from "../ErrorBoundary";
export const Banner = ({ hero, tagline, title }) => {
  const configData = useConfig();
  const searchBarConfig = configData?.mfes["PlatformSearchBar"];
  const [isSearchLoaded, setIsSearchLoaded] = useState(false);
  const { containerName, module, remoteUrl } = searchBarConfig || {};
  const onSearchMfeLoad = () => setIsSearchLoaded(true);
  const backgroundImage = `url(${hero})`;
  const isMobile = useMediaQuery("max", "sm");

  return (
    <StyledWrap
      $isMobile={isMobile}
      container
      column
      align={{
        items: "center",
      }}
      maxWidth="initial"
      style={{
        backgroundImage,
      }}
    >
      {title && (
        <StyledHeading element="h2" color="white" fontWeight="light">
          {title}
        </StyledHeading>
      )}
      {tagline && (
        <StyledParagraph
          color="white"
          fontWeight="light"
          element="p"
          fontSize="md"
        >
          {tagline}
        </StyledParagraph>
      )}
      <StyledSearch
        $isMobile={isMobile}
        data-testid="search-wrapper"
        container
        column
        justify={{
          content: "center",
        }}
      >
        {!isSearchLoaded && (
          <StyledSearchLoader>
            <Skeleton kind="rect" width={80} height={20} animate />
            <Skeleton kind="circle" width={20} height={20} animate />
          </StyledSearchLoader>
        )}
        {remoteUrl && (
          <ErrorBoundary team="cd.bauhaus">
            <ModuleLoader
              containerName={containerName}
              module={module}
              remoteUrl={remoteUrl}
              onLoad={onSearchMfeLoad}
            />
          </ErrorBoundary>
        )}
      </StyledSearch>
    </StyledWrap>
  );
};
export default Banner;
